import { onGameEvent, EVENTS } from './game-events.js'
import { getValidWordRows, focusGuessInput, revealTiles } from './dom.js'

/**
 * Reveals the guess board: flips in each already-made guess row, then
 * focuses the guess input. Safe to call on any page load - a no-op
 * wherever there's no '.valid-word-row'/'#active-row' to act on.
 *
 * Bound to two triggers: a real page load never goes through htmx, so
 * DOMContentLoaded covers that; GAME_LOADED (see itword/views.py) covers an
 * htmx-driven reload of the board. Only ever animates the reveal - never
 * celebrates, even if the round was already won before this load (that's
 * GAME_FINISHED's job, see game-finished.js).
 */
const revealGuesses = () => {
    getValidWordRows().forEach((row, rowIndex) => {
        setTimeout(() => {
            revealTiles(row, row.querySelectorAll('.valid-word-letter'))
        }, rowIndex * 150)
    })

    focusGuessInput()
}

document.addEventListener('DOMContentLoaded', revealGuesses)
onGameEvent(EVENTS.GAME_LOADED, revealGuesses)
